import React from 'react';
import { Col, Container, Row } from 'reactstrap';

const Footer = () => {
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © Vuelo.
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                Todos los derechos reservados. |
                                {" "}
                                <a
                                    href="https://papagayodev.com/web/#!/portfolio"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-primary fw-semibold text-decoration-none"
                                >
                                    PapagayoDev
                                </a>
                            </div>

                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
